import { render, staticRenderFns } from "./FormPalveluhakemusPerustiedot.vue?vue&type=template&id=685c7beb&scoped=true&"
import script from "./FormPalveluhakemusPerustiedot.vue?vue&type=script&lang=js&"
export * from "./FormPalveluhakemusPerustiedot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685c7beb",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('685c7beb')) {
      api.createRecord('685c7beb', component.options)
    } else {
      api.reload('685c7beb', component.options)
    }
    module.hot.accept("./FormPalveluhakemusPerustiedot.vue?vue&type=template&id=685c7beb&scoped=true&", function () {
      api.rerender('685c7beb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormPalveluhakemusPerustiedot.vue"
export default component.exports